import { Dropdown, Grid } from "antd";
import { ItemType } from "antd/es/menu/interface";
import GlobeDemo from "../../../../assets/images/icons/GlobeDemo";
import CustomDrawer from "../../../CustomDrawer";
import { LanguageResponse } from "../../data";
import styles from "./styleModule";

const LanguageContainer = ({
  languageDropdown,
  onClick,
  handleOpenChange,
  setShowDrawer,
  onClose,
  showDrawer,
  renderLanguageList,
}: {
  languageDropdown: LanguageResponse[];
  onClick: (e: any) => void;
  handleOpenChange: (open: boolean) => void;
  setShowDrawer: (value: boolean) => void;
  onClose: () => void;
  showDrawer: boolean;
  renderLanguageList: () => React.ReactNode;
}) => {
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  return (
    <div>
      {screens.md ? (
        <Dropdown
          menu={{ items: languageDropdown as ItemType[], onClick }}
          trigger={["click"]}
          placement="bottomRight"
          onOpenChange={handleOpenChange}
        >
          <div className={styles.globeIcon}>
            <GlobeDemo style={{ fontSize: 24, color: "var(--primary)" }} />
          </div>
        </Dropdown>
      ) : (
        <div
          className={styles.globeIcon}
          onClick={() => {
            setShowDrawer(true);
          }}
        >
          <GlobeDemo style={{ fontSize: 24, color: "var(--primary)" }} />
        </div>
      )}
      <CustomDrawer
        placement={"left"}
        closable={true}
        onClose={onClose}
        open={showDrawer}
        size={"large"}
        width={"100vw"}
      >
        <div className={styles.drawerBodyContainer}>{renderLanguageList()}</div>
      </CustomDrawer>
    </div>
  );
};

export default LanguageContainer;
